import React, { useState } from "react";
import "./WeatherTemperature.css";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");
  function convertToFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function convertToCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div>
        <h4 className="currentTemp">
          {Math.round(props.celsius)}
          <span className="unit">
            {" "}
            ºC |{" "}
            <a href="/" className="link" onClick={convertToFahrenheit}>
              ºF
            </a>
          </span>
        </h4>
      </div>
    );
  } else {
    let fahrenheit = (props.celsius * 9) / 5 + 32;
    return (
      <div>
        <h4 className="currentTemp">
          {Math.round(fahrenheit)}
          <span className="unit">
            <a href="/" className="link" onClick={convertToCelsius}>
              {" "}
              ºC
            </a>{" "}
            | ºF
          </span>
        </h4>
      </div>
    );
  }
}
